import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { JobProcedureService } from '../services/sections/job/job-procedure.service';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { catchError, tap } from 'rxjs/operators';
import { JobProcedureCopilotConfirmationDetails } from '../models/procedure-copilot-confirmation-details.model';

@Injectable({
  providedIn: 'root'
})
export class ProcedureCopilotConfirmationResolver implements Resolve<JobProcedureCopilotConfirmationDetails> {
    constructor(
      private router: Router,
      private procedureService: JobProcedureService
    ) {}
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
      GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.procedureService
			.getProcedureCopilotConfirmationDetails(route.paramMap.get('token'))
			.pipe(
				catchError(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					this.router.navigate(['/404']);
					return NEVER;
				})
			);
    }
}
